import { compact } from "lodash";
import {
  AssessmentGroupDelivery,
  ComplianceProgramParticipantStatus,
  GetComplianceProgramProgressQuery,
} from "types/graphql-schema";

import AppPopover from "@components/popover/app-popover";
import StatusPill, {
  StatusPillEnum,
} from "@components/status-pill/status-pill";

import {
  ComplianceProgramReportingEntityTableCol,
  ComplianceProgramReportingEntityTableParticipantStatusWithNominations,
} from "./compliance-program-progress-entity-table";
import ProgramProgressPillPopoverPanel from "./program-progress-pill-popover-panel";

const ProgramProgressPill = ({
  className,
  status,
  col,
  complianceProgram,
  participantStatus,
}: {
  col: ComplianceProgramReportingEntityTableCol;
  participantStatus: ComplianceProgramReportingEntityTableParticipantStatusWithNominations;
  className?: string;
  status: ComplianceProgramParticipantStatus;
  complianceProgram: NonNullable<
    GetComplianceProgramProgressQuery["complianceProgram"]
  >;
}) => {
  const pillStatus =
    status === ComplianceProgramParticipantStatus.NotApplicable
      ? StatusPillEnum.NotApplicable
      : status === ComplianceProgramParticipantStatus.NotStarted
      ? StatusPillEnum.NotApplicable
      : status === ComplianceProgramParticipantStatus.InProgress
      ? StatusPillEnum.InProgress
      : StatusPillEnum.Complete;

  const statusLabel =
    status === ComplianceProgramParticipantStatus.NotStarted
      ? col.keyName === "oneononeStatus"
        ? "Not Scheduled"
        : col.keyName === "calibrationStatus"
        ? "Not Calibrated"
        : col.keyName === "deliveryStatus"
        ? compact([
            complianceProgram.performanceAssessmentTemplate,
            complianceProgram.managerAssessmentTemplate,
            complianceProgram.peerAssessmentTemplate,
          ]).some(
            (template) =>
              template.delivery === AssessmentGroupDelivery.AdminApproval
          )
          ? "Not Approved"
          : "Not Shared"
        : "Not Started"
      : status === ComplianceProgramParticipantStatus.InProgress
      ? col.keyName === "deliveryStatus"
        ? "Approved"
        : "In Progress"
      : status === ComplianceProgramParticipantStatus.Complete
      ? col.keyName === "deliveryStatus"
        ? "Shared"
        : col.keyName === "calibrationStatus"
        ? "Calibrated"
        : "Complete"
      : "N/A";

  return (
    <div className="flex gap-2 items-center">
      <AppPopover
        content={({ open }) =>
          open && (
            <ProgramProgressPillPopoverPanel
              participantStatus={participantStatus}
              status={status}
              col={col}
              complianceProgram={complianceProgram}
            />
          )
        }
      >
        <AppPopover.Button className="outline-none focus:outline-none focus:ring-0">
          {status === ComplianceProgramParticipantStatus.NotApplicable ? (
            <div className="text-gray-500 text-sm">{statusLabel}</div>
          ) : (
            <StatusPill
              status={pillStatus}
              label={statusLabel}
              className={className}
            />
          )}
        </AppPopover.Button>
      </AppPopover>
    </div>
  );
};

export default ProgramProgressPill;
